import * as React from 'react';
import {useState, useEffect, useMemo, useCallback} from 'react';
import {render} from 'react-dom';
import Map, {Source, Layer} from 'react-map-gl';

import {dataLayer} from './map-style';


const MAPBOX_TOKEN = 'pk.eyJ1Ijoic2h1eXV6aGFuZyIsImEiOiJja3g5MDlzcmYwcmRzMnZueDR1aGhwODhsIn0.kKykOyCEZtoNNm5hjWG3Iw'; // Set your mapbox token here


function Trips() {
  const [year, setYear] = useState(2015);
  const [allData, setAllData] = useState(null);
  const [hoverInfo, setHoverInfo] = useState(null);

  useEffect(() => {
    /* global fetch */
    fetch(
      'https://raw.githubusercontent.com/Lionelsy/MapData/main/Trips.json'
    )
      .then(resp => resp.json())
      .then(json => setAllData(json))
      .catch(err => console.error('Could not load data', err)); // eslint-disable-line
  }, []);

  const onHover = useCallback(event => {
    const {
      features,
      point: {x, y}
    } = event;
    const hoveredFeature = features && features[0];

    // prettier-ignore
    setHoverInfo(hoveredFeature && {feature: hoveredFeature, x, y});
  }, []);

  const data = useMemo(() => {
    return allData;
  }, [allData, year]);

  return (
    <>
      <Map
        initialViewState={{
          latitude: 35.8617,
          longitude: 104.1954,
          zoom: 4
        }}
        mapStyle="mapbox://styles/mapbox/light-v9"
        mapboxAccessToken={MAPBOX_TOKEN}
        interactiveLayerIds={['data']}
        onMouseMove={onHover}
      >
        <Source type="geojson" data={data}>
          <Layer {...dataLayer} />
        </Source>
        {hoverInfo && (
          <div className="tooltip" style={{left: hoverInfo.x, top: hoverInfo.y}}>
            <div>Hello: {hoverInfo.feature.properties.city}</div>
            <div>World: {hoverInfo.feature.properties.description}</div>
          </div>
        )}
      </Map>

      {/* <ControlPanel year={year} onChange={value => setYear(value)} /> */}
    </>
  );
}

export default Trips
